<div>
  <app-generic-table class="col-span-1 order-2 xl:order-1 xl:col-span-2"
                     [loading]="loading"
                     [tableHeaders]="tableHeaders"
                     (changeSorts)="onChangeSorts($event)"
                     [tableActions]="tableActions"
                     (clickAction)="onClickAction($event)"
                     [filters]="filters"
                     [showDirectAction]="true"
                     #genericTableComponent
                     [items]="vehicles">

    <app-table-header-wrapper GTHeader >
      <!--<app-user-table-filters [perPageOptions]="[50,100,150,200]" (onChangePerPage)="perPage = $event; loadReservations()" [perPage]="perPage" [tableHeaders]="tableHeaders" [filters]="filters" (onChangeFilters)="onChangeFilters($event)"></app-user-table-filters>-->
      <app-table-filters
        [loading]="loadingFilters"
        [filters]="filters"
        [displayNames]="displayNames"
        [filtersList]="tableFilters"
        [perPageOptions]="[50,100,150,200]"
        [perPage]="perPage"
        (onChangeFilters)="onChangeFilters($event)"
        [tableHeaders]="tableHeaders">

      </app-table-filters>
    </app-table-header-wrapper>
  </app-generic-table>
</div>

<ng-container *ngIf="editVehicle && editForm">
  <div (click)="closeEditModal()" class="fixed inset-0 bg-black bg-opacity-35 animate-fade-in cursor-pointer z-40"></div>
  <div (click)="closeEditModal()" class="fixed inset-0 flex items-center justify-center px-8 h-full z-50">
    <div (click)="$event.stopPropagation()" class="bg-white p-8 rounded-lg shadow-lg w-full max-w-2xl animate-fade-in-up">

      <form [formGroup]="editForm" (ngSubmit)="update()" class="mt-8 animate-fade-in">
        <div class="w-full mx-auto flex flex-col gap-4">
          <div>
            <label appFormLabel>Nombre del tipo de vehiculo *</label>
            <input appFormInput type="text" formControlName="name">
            <span *ngIf="editForm.get('name')?.touched && editForm.get('name')?.invalid" appFormError>
              El nombre del tipo de vehiculo es requerido
            </span>
          </div>

          <div>
            <label appFormLabel>Nombre del tipo de vehiculo (Catalán)</label>
            <input appFormInput type="text" formControlName="name_cat">
          </div>


          <div>
            <label appFormLabel>Nombre corto del tipo de vehiculo *</label>
            <input appFormInput type="text" formControlName="short_name">
            <span *ngIf="editForm.get('short_name')?.touched && editForm.get('short_name')?.invalid" appFormError>
              El nombre corto del tipo de vehiculo es requerido
            </span>
          </div>

          <div>
            <label appFormLabel>Tipo *</label>
            <select appFormInput formControlName="type">
              <option value="open">ABIERTO</option>
              <option value="message">MENSAJE</option>
              <option value="locked">BLOQUEADO</option>
            </select>
          </div>

          <div *ngIf="editForm.get('type')?.value == 'message'">
            <label appFormLabel>Mensaje</label>
            <textarea rows="5" appFormInput formControlName="no_open_message" ></textarea>
          </div>

          <div>
            <label appFormLabel>Imagen</label>

            <div *ngIf="newImagePreviewUrl; else currentImage" class="flex justify-center mb-4">
              <img class="w-24 h-24" [src]="newImagePreviewUrl" alt="Previsualización de la imagen">
            </div>
            <ng-template #currentImage>
              <div *ngIf="editVehicle.item.logo && !newImage" class="flex justify-center mb-4">
                <img class="w-24 h-24" [src]="editVehicle.item.logo.original_url" [alt]="editVehicle.item.name">
              </div>
            </ng-template>

            <div
              (click)="imageInput.click()"
              class="cursor-pointer inline-block bg-green text-white font-semibold py-2 px-4 rounded-lg shadow-lg transition duration-300">
              <span *ngIf="newImagePreviewUrl">CAMBIAR IMAGEN</span>
              <span *ngIf="!newImagePreviewUrl">SUBIR IMAGEN</span>
            </div>
            <!--<div class="mt-4">
              <label appFormLabel>Otro id</label>
              <input appFormInput formControlName="other_id">
            </div>-->

            <div class="mt-4">
              <label appFormLabel>Claves</label>
              <input appFormInput formControlName="itv_key">
              <span class="text-xs text-darkGray">Es importante separar cada valor con ,</span>
            </div>

            <input style="display:none;"  (change)="onFileChange($event)" #imageInput class="mt-4" type="file">
          </div>



         <!-- <file-pond #myPond
                     [options]="pondOptions"
                     [files]="pondFiles"
                     >
          </file-pond>-->


          <div class="w-full flex justify-between">
            <button (click)="closeEditModal()" type="button" class="bg-red-500 text-white shadow-sm p-2 px-4 rounded-2xl">
              Cancelar
            </button>
            <button [disabled]="loadingEdit" type="submit" class="bg-primary text-white shadow-sm p-2 px-4 rounded-2xl text flex items-center gap-4">
              Editar <app-loader *ngIf="loadingEdit" size="extra-small"></app-loader>
            </button>
          </div>
        </div>


      </form>
    </div>
  </div>
</ng-container>
